import { ContextualTabbedSettings } from '@components'

import { YStack } from '@shinetools/lumen-react'
import { Mail } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

const { ContextualSettingInput, CopySettingsButton, MainSettingCta } = ContextualTabbedSettings

export const MagicMailSettings = () => {
  const { organization, isLoading } = useUserOrganization()
  const { t } = useTranslation()

  return (
    <YStack gap={16}>
      <MainSettingCta description={t('purchases.settings.magicmail.description')} />
      <ContextualSettingInput isLoading={isLoading} icon={Mail} label={organization?.billEmailAddress ?? ''}>
        <CopySettingsButton textToCopy={organization?.billEmailAddress ?? ''} />
      </ContextualSettingInput>
    </YStack>
  )
}
